/* Back in Stock, Anmeldung unter dem Kaufknopf.
   Gehoert zu snippets/ps-back-in-stock.liquid.

   Zwei Dinge macht diese Datei:
   1. Sie entscheidet je Variante, ob das Formular sichtbar ist. Das Theme
      wechselt Varianten ohne Seitenwechsel und schreibt die neue ID in den
      versteckten Eingang .product-buy-buttons--input. Darauf hoert ein
      MutationObserver - unabhaengig davon, wie das Theme intern umschaltet.
   2. Sie meldet die Adresse bei Klaviyo an, ueber die Client-API. Die
      braucht keinen geheimen Schluessel, nur die oeffentliche Kontokennung.

   Kein <form> und kein type="submit": das Snippet sitzt im Produktformular.
   Verschachtelte Formulare bricht der Browser auf, und ein Submit wuerde das
   Produkt in den Warenkorb legen. Enter im Feld loest deshalb den Knopf aus.
*/
(function () {
  'use strict';

  var ENDPUNKT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var REVISION = '2024-10-15';

  function start(wurzel) {
    if (wurzel.dataset.psBisBereit === '1') return;
    wurzel.dataset.psBisBereit = '1';

    var daten;
    try {
      daten = JSON.parse(wurzel.querySelector('[data-ps-bis-daten]').textContent);
    } catch (e) {
      return;
    }
    var texte = daten.texte || {};
    var kaufbar = {};
    (daten.varianten || []).forEach(function (v) { kaufbar[String(v.id)] = !!v.kaufbar; });

    var form = wurzel.querySelector('.ps-bis-form');
    var feld = wurzel.querySelector('.ps-bis-feld');
    var knopf = wurzel.querySelector('.ps-bis-knopf');
    var meldung = wurzel.querySelector('[data-ps-bis-meldung]');
    var haken = wurzel.querySelector('[data-ps-bis-newsletter]');
    var eingang = document.querySelector('.product-buy-buttons--input');

    function aktuelleVariante() {
      if (!eingang) return null;
      return eingang.getAttribute('data-id') || eingang.value || null;
    }

    function sagen(text, art) {
      meldung.textContent = text || '';
      if (art) { meldung.setAttribute('data-art', art); }
      else { meldung.removeAttribute('data-art'); }
    }

    var zuletzt = null;
    function pruefen() {
      var id = aktuelleVariante();
      if (id === zuletzt) return;
      zuletzt = id;
      // Unbekannte Variante: lieber nichts zeigen als das Falsche.
      var zeigen = id !== null && kaufbar[String(id)] === false;
      wurzel.hidden = !zeigen;
      if (zeigen) { sagen('', null); }
    }

    pruefen();
    if (eingang) {
      new MutationObserver(pruefen).observe(eingang, {
        attributes: true, attributeFilter: ['data-id', 'value']
      });
      eingang.addEventListener('change', pruefen);
    }
    // Das Theme feuert bei Variantenwechsel nicht zuverlaessig ein Ereignis,
    // deshalb zusaetzlich ein ruhiger Takt. 800 ms reichen, der Vergleich
    // oben verhindert Arbeit, solange sich nichts aendert.
    setInterval(pruefen, 800);

    // Zweiter, getrennter Aufruf: nur wenn das Haekchen gesetzt ist.
    // Die Liste laeuft mit Double-Opt-in, Klaviyo schickt die Bestaetigung.
    // Schlaegt er fehl, bleibt die Benachrichtigung bestehen - sie ist der
    // Grund, warum der Kunde hier war.
    function newsletter(mail) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='
            + encodeURIComponent(daten.company), {
        method: 'POST',
        headers: { 'revision': REVISION, 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              // Kein subscriptions-Objekt: die Client-API weist es ab mit
              // "'subscriptions' is not a valid field for the resource
              // 'profile'", am 27.09.2026 gemessen. Die Einwilligung ergibt
              // sich aus dem Opt-in-Verfahren der Liste - UQB2nK laeuft mit
              // Double-Opt-in, Klaviyo schickt also die Bestaetigungsmail.
              profile: { data: { type: 'profile', attributes: { email: mail } } },
              custom_source: 'Back in Stock Formular'
            },
            relationships: { list: { data: { type: 'list', id: daten.liste } } }
          }
        })
      }).then(function (a) {
        // Erst jetzt darf die Meldung den Newsletter erwaehnen. Vorher stand
        // dort "schau in dein Postfach", auch wenn der Aufruf fehlschlug.
        if (a.status === 202 || a.ok) { sagen(texte.fertigPlus, 'fertig'); }
      }).catch(function () { /* die Benachrichtigung steht, das genuegt */ });
    }

    feld.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); knopf.click(); }
    });

    knopf.addEventListener('click', function () {
      var mail = (feld.value || '').trim();
      if (!mail || mail.indexOf('@') < 1 || mail.indexOf('.') < 0) {
        sagen(texte.ungueltig, 'fehler');
        feld.focus();
        return;
      }
      var id = aktuelleVariante();
      if (!id) { sagen(texte.fehler, 'fehler'); return; }

      knopf.disabled = true;
      sagen(texte.laeuft, null);

      fetch(ENDPUNKT + '?company_id=' + encodeURIComponent(daten.company), {
        method: 'POST',
        headers: { 'revision': REVISION, 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: mail } } },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id }
              }
            }
          }
        })
      }).then(function (a) {
        if (a.status === 202 || a.ok) {
          // Immer die schlichte Meldung; newsletter() erweitert sie nur,
          // wenn der zweite Aufruf wirklich durchgeht.
          sagen(texte.fertig, 'fertig');
          form.hidden = true;
          if (haken && haken.checked) { newsletter(mail); }
        } else {
          knopf.disabled = false;
          sagen(texte.fehler, 'fehler');
        }
      }).catch(function () {
        knopf.disabled = false;
        sagen(texte.fehler, 'fehler');
      });
    });
  }

  function alle() {
    document.querySelectorAll('[data-ps-bis]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }
}());
